// extracted by mini-css-extract-plugin
export default {"dlReportLink":"src-js-common-components-formatters-ReportLinkFormatter---dlReportLink---y+Srl"};